import { Currency, FormatMoneyOptions } from '@orbis-systems/orbis-react-toolkit';
import { isNull, isNumber, isString } from 'lodash';

export const formatMoneyWithCurrencyCode = (value?: number | string, options: FormatMoneyOptions = {}): string => {
    if (isNaN(Number(value))) {
        return '-';
    }

    const {
        decimalPlaces = 2,
        short = false,
        aliasForZero = false,
        trimZeros = false,
        localeCode = 'en-US',
        currency = Currency.UsDollar,
    } = options;

    const validatedCurrency = isNull(currency) ? Currency.UsDollar : currency;

    const formatter = new Intl.NumberFormat(localeCode, {
        style: 'decimal',
        currency: validatedCurrency,
        minimumFractionDigits: trimZeros ? 0 : decimalPlaces < 2 ? decimalPlaces : 2,
        maximumFractionDigits: trimZeros ? 0 : decimalPlaces,
        notation: short ? 'compact' : undefined,
    });

    if (aliasForZero && isNumber(value) && value === 0) {
        return isString(aliasForZero) ? aliasForZero : 'N/A';
    } else {
        const amount = formatter.format(Number(value));

        return `${validatedCurrency} ${amount}`;
    }
};
